import React, { useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import ViewModalImage from 'modules/common/components/ViewModalImage';

function PropertyLocation({ data }) {
  const setModal = useContext(ModalContext);

  const handleViewImage = (value) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      title: 'View Sketch',
      content: <ViewModalImage value={value} />,
      modalSize: 'modal-lg',
    });
  };

  return (
    <div className="row d-flex mb-1 p-3">
      <div className="col-12 mt-1">
        <span className="title-color">Property Location</span>
      </div>
      <div className="col-12">
        <table className="transaction-table table table-borderless table-striped table-sm ">
          <tbody>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Location
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_location_name') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Province
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_province_name') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                District
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_district_name') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Barangay
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_barangay_name') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Street
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.property_street') || '--'}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="col-12 mt-1">
        <span className="title-color">Boundaries</span>
      </div>
      <div className="col-12">
        <table className="transaction-table table table-borderless table-striped table-sm ">
          <tbody>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                North
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_boundaries_north') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                South
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_boundaries_south') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                East
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_boundaries_east') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                West
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.property_boundaries_west') || '--'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="col-12 pt-2 border-top">
        <span className="title-color">Sketch</span>
      </div>
      <div className="col-12">
        <table className="transaction-table table table-borderless table-striped table-sm ">
          <tbody>
            <tr className="bg-white">
              <td className="span-title2 font-weight-bold" width="250" />
              <td className="text-dark" width="1" />
              <td>
                <span className="transaction-text p-0">
                  <button
                    type="button"
                    onClick={handleViewImage(
                      _.get(
                        data,
                        'attributes.property_boundaries_land_sketch_photo_url'
                      )
                    )}
                  >
                    <img
                      className="w-100 rounded"
                      src={
                        !_.isObject(
                          _.get(
                            data,
                            'attributes.property_boundaries_land_sketch_photo_url'
                          ) || ''
                        )
                          ? _.get(
                              data,
                              'attributes.property_boundaries_land_sketch_photo_url'
                            ) || ImagePlaceholder
                          : _.get(
                              data,
                              'attributes.property_boundaries_land_sketch_photo_url.cdnUrl'
                            ) || ImagePlaceholder
                      }
                      alt=""
                    />
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

PropertyLocation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default PropertyLocation;
